import { gql } from "@apollo/client";

export const VIEW_ALL_LIBRARY_PODCAST_ADMIN = gql`
  query GetMylibraryPodcastsForAdmin(
  $subjectId: UUID!
  $searchInput: String = "%%"
  $classroomIds: [UUID!]
) {
  getMylibraryPodcastsForAdmin(
    pSubjectId: $subjectId
    filter: { filename: { likeInsensitive: $searchInput } }
    pClassroomIds: $classroomIds
  ) {
    nodes {
      fileId
      filename
      filepath
      filesize
      isclassroom: isClassroom
      subjectId
      fileDescription
      coverImagePath
    }
    totalCount
  }
}
`;

export const UPLOAD_PODCAST_ADMIN = gql`
  mutation UploadMylibraryPodcastsBySchoolAdmin(
  $files: JSON!
  $classroomIds: [UUID!]
  $subjectId: UUID!
) {
  uploadMylibraryPodcastsBySchoolAdmin(
    input: {
      pFiles: $files
      pClassroomIds: $classroomIds
      pSubjectId: $subjectId
    }
  ) {
    result: json
  }
}
`;
